<template>
  <div class="subscription-feature" :class="[ theme ? `theme-${theme}` : '']">
    <div class="subscription-feature__main">
      <div class="main__name">
        <p>
          <span>{{ _get(feature, 'Feature.name') }}</span>
          <a @click="showMoreInformation = !showMoreInformation">
            <template v-if="!showMoreInformation">
              {{ $t('label.more') }}<i class="far fa-angle-down"></i>
            </template>
            <template v-else>
              {{ $t('label.less') }}<i class="far fa-angle-up"></i>
            </template>
          </a>
        </p>
      </div>
      <div class="subscription-feature__more-less">
      </div>
      <div class="main__options">
        <template v-if="checkIsFutureFeature(feature)">
          <template v-if="type === 'standard'">
            <el-tooltip class="item" effect="dark" placement="top-end" :open-delay="1000" :content="$t('label.included_when_available_help')">
              <span class="main__options__feature--text">{{ $t('label.included_when_available') }}</span>
            </el-tooltip>
          </template>
          <template v-else>
            <el-tooltip class="item" effect="dark" placement="top-end" :open-delay="1000" :content="$t('label.upgrade_when_available_help')">
              <span v-if="type === 'extended'" class="main__options__feature--text">{{ $t('label.upgrade_when_available') }}</span>
            </el-tooltip>
          </template>
        </template>
        <template v-else>
          <nuttrema-radiocheck-group
             v-model="selected"
            :mode="featureMode"
            :required="!_get(feature, 'extension')"
            :disabled="!customize || checkIsFutureFeature(feature)"
            :theme="theme"
            @change="updateSelected">
            <template v-for="option in feature.SubscriptionFeatureOptions">

              <template v-if="checkIsFutureFeature(option)">
                <el-tooltip class="item" effect="dark" placement="top-end" :open-delay="1000" :content="$t('label.upgrade_when_available_help')">
                  <nuttrema-radiocheck-button
                    :future="true"
                    :key="option.id"
                    :label="option.id">
                    {{ option.name }}
                  </nuttrema-radiocheck-button>
                </el-tooltip>
              </template>

              <template v-else>
                <el-tooltip class="item" effect="dark" placement="top-end" :open-delay="1000">
                  <div slot="content">
                    <p v-for="(price, index) in option.PriceOptions">
                      <template v-if="checkCurrencyAndPaymenPlan(price)">
                        {{ price.description }} {{ price.price }} {{ _get(price, 'Currency.symbol') }} {{ _get(price, 'PaymentPlan.suffix') }}
                      </template>
                      <template v-else-if="index === 0">
                        {{ $t('label.no_extra_charge') }}
                      </template>
                    </p>
                  </div>
                  <nuttrema-radiocheck-button
                    :label="option.id"
                    :key="option.id"
                    :required="!_get(option, 'user_selectable')">
                    {{ option.name }}
                  </nuttrema-radiocheck-button>
                </el-tooltip>
              </template>

            </template>
          </nuttrema-radiocheck-group>
        </template>


      </div>
    </div>
    <div class="subscription-feature__more">
      <div class="more-option-description" v-if="showMoreInformation">
        <div class="more-option-description__item" v-for="option in feature.SubscriptionFeatureOptions">
          <span class="more-option-description--feature-name">{{ option.name }}</span> - {{ option.description }}
        </div>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
import { get, filter, find, map, isArray, isNil, includes } from 'lodash';

import NuttremaRadiocheckGroup from 'components/ui/button/nuttrema-radiocheck-group';
import NuttremaRadiocheckButton from 'components/ui/button/nuttrema-radiocheck-button';

import SubscriptionFeatureAbstract from './cmpt-subscription-feature-abstract';

export default {
  name: 'cmpt-subscription-feature',
  mixins: [SubscriptionFeatureAbstract],
  props: {
    value: {
      required: false,
      default: null,
    },
    feature: {
      type: Object,
      required: true,
      default: null,
    },
    type: {
      type: String,
      required: true,
      default: null,
    },
    selectedCurrencyID: {
      required: true,
      default: null,
    },
    selectedPaymentPlanID: {
      required: false,
      default: null,
    },
    customize: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    NuttremaRadiocheckGroup,
    NuttremaRadiocheckButton,
  },
  data() {
    return {
      selected: null,
      clone: null,
      showMoreInformation: false,
    };
  },
  methods: {
    checkIsFutureFeature(feature) {
      return get(feature, 'status') === 'future';
    },
    checkCurrencyAndPaymenPlan(price) {
      return Number(price.price) !== 0 && get(price, 'Currency.id') === this.selectedCurrencyID;
    },
    findSelectedByID(id) {
      const feature = get(this.feature, 'Feature', null);
      const code = get(this.feature, 'Feature.code', null);
      const options = get(this.feature, 'SubscriptionFeatureOptions', null);

      let entity = null;

      if (isArray(id)) {
        entity = filter(options, item => includes(id, item.id));
        id = map(entity, 'id') || [];
      } else {
        entity = find(options, item => id === item.id);
        id = get(entity, 'id', null);
      }

      return {
        code,
        entity,
        feature,
        id,
      };
    },
    getInitialSelected() {
      const optionSelection = get(this.feature, 'option_selection', 'single');

      const feature = get(this.feature, 'Feature', null);
      const code = get(this.feature, 'Feature.code', null);
      const options = get(this.feature, 'SubscriptionFeatureOptions', null);

      let id = null;
      let entity = null;

      if (optionSelection === 'single') {
        entity = find(options, item => item.selected);
        id = get(entity, 'id', null);
      } else {
        entity = filter(options, item => item.selected);
        id = map(entity, 'id') || [];
      }

      return {
        code,
        entity,
        feature,
        id,
      };
    },
    setInitialSelected() {
      const selected = this.getInitialSelected();
      // console.log('setSelected', selected);
      if (!isNil(get(selected, 'entity'))) {
        this.selected = selected.id;
        this.updateValue(selected.code, selected.entity, selected.feature);
      }
    },
    updateSelected() {
      const id = this.selected;
      const selected = this.findSelectedByID(id);
      // console.log('updateSelected', id, selected);
      if (!isNil(get(selected, 'entity'))) {
        this.selected = selected.id;
        this.updateValue(selected.code, selected.entity, selected.feature);
      } else {
        this.removeValue(selected.code);
      }
    },
    removeValue(code) {
      this.$emit('remove', { code });
    },
    updateValue(code, val, feature) {
      let value = [];

      if (isArray(val)) value = val;
      else value.push(val);

      this.$emit('input', {
        code,
        value,
        feature,
      });
    },
  },
  computed: {
    featureMode() {
      return get(this.feature, 'option_selection', 'single') === 'single' ? 'radio' : 'checkbox';
    },
  },
  watch: {
    // feature() {
    //   this.setSelected();
    // },
    // selected() {
    //   this.updateSelected();
    // },
  },
  created() {
    this.setInitialSelected();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-subscription-feature.vue